<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12.0571" r="11" fill="#4DB051" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.0303 8.5268C17.3232 8.81969 17.3232 9.29457 17.0303 9.58746L11.4053 15.2125C11.1124 15.5054 10.6376 15.5054 10.3447 15.2125L7.46967 12.3375C7.17678 12.0446 7.17678 11.5697 7.46967 11.2768C7.76256 10.9839 8.23744 10.9839 8.53033 11.2768L10.875 13.6215L15.9697 8.5268C16.2626 8.23391 16.7374 8.23391 17.0303 8.5268Z"
      fill="#FAFAFA" />
  </svg>
</template>
